import React from 'react';
import {Page} from 'utils/page-utils';
import {loadable} from 'router/routes';
import getInitialStateDestinationContext from 'pages/search-transient-event-monthly/redux/get-initial-state-destination-context';

/*
    Destination routes correspond to different Search page components based on:
    - whether this is a transient or monthly search
    - whether this is desktop or mobile experience
    - MidFunnel landing pages for destinations

    The destination route could be simplified by doing the following:
    1. Merging mobile and desktop features
*/

const SearchMobileDestination = loadable(() =>
    import('pages/search-transient-event-monthly/SearchMobileDestination')
);
const SearchMobileMonthly = loadable(() =>
    import('pages/search-transient-event-monthly/SearchMobileMonthly')
);
const SearchDesktopDestination = loadable(() =>
    import('pages/search-transient-event-monthly/SearchDesktopDestination')
);
const SearchDesktopMonthly = loadable(() =>
    import('pages/search-transient-event-monthly/SearchDesktopMonthly')
);
const DestinationMidFunnel = loadable(() => import('./MidFunnelDestination'));
const SearchAirport = loadable(() =>
    import('pages/search-airport/SearchAirport')
);

/* eslint-disable react/prop-types */
const DestinationSearch = ({configData: {isMobile}, isMonthly, destination}) =>
    isMobile && isMonthly ? (
        <SearchMobileMonthly />
    ) : isMobile ? (
        <SearchMobileDestination />
    ) : isMonthly ? (
        <SearchDesktopMonthly />
    ) : destination?.airport ? (
        <SearchAirport />
    ) : (
        <SearchDesktopDestination />
    );

const Destination = props =>
    props.pageType === Page.MID_FUNNEL ? (
        <DestinationMidFunnel />
    ) : (
        <DestinationSearch {...props} />
    );

/* eslint-enable react/prop-types */

Destination.getInitialState = getInitialStateDestinationContext;

export default Destination;
